import type {I18n} from "@lingui/core";
import type {GroupRepo, UnitId} from "./GroupRepo";
import {useIndex} from "./use-index";

export const useSortedUnitIds = (groupRepo: GroupRepo) => {
  return useIndex<UnitId>("", groupRepo.indexes, "sortedUnits");
};

export const useSortedUnits = (groupRepo: GroupRepo) => {
  const ids = useSortedUnitIds(groupRepo);
  const unitEntries = groupRepo.Units.useGetAll();
  return ids.map((id) => unitEntries[id]);
};

export const useUnitList = (groupRepo: GroupRepo, i18n: I18n): UnitList => {
  const units = useSortedUnits(groupRepo);
  return [
    {label: i18n._("units.piece"), value: null},
    ...units.map((unit) => ({label: unit.name, value: unit.name})),
  ];
};

export type UnitList = {label: string; value: string | null}[];
